import { render, staticRenderFns } from "./MbInputText.vue?vue&type=template&id=30dfed3c&"
import script from "./MbInputText.vue?vue&type=script&lang=js&"
export * from "./MbInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports